import { Input, KeyCode } from "../../../lib/Input";
import { Physics } from "../../../math/Physics";
import Ability from "../../Ability";
import Player from "../../Player";

export default class EnergyTransfer extends Ability {

    constructor(player: Player) {
        super(player, {
            cooldown: 20,
            duration: 0,
            energyCost: 30,
            icon: 13,
            trigger: KeyCode.Digit2,
            triggerType: Input.GetKeyUp,
            info: `Energy Transfer (20s cooldown) - Instantly restore 30 energy to a teammate under your cursor`
        })
    }

    onUse(): void {
        const validPlayers = this.player.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team === this.player.team && !this.player.Equals(v)
        );

        for (const player of validPlayers) {
            if (Physics.CircleCircleCollision({
                position: this.player.engine.mouseWorldPosition,
                radius: 32
            }, {
                position: player.transform.position,
                radius: player.size
            }) !== false) {
                this.player.engine.sendRestoreEnergyPacket(player, this.energyCost);
                return;
            }
        }

        this.player.energy += this.energyCost;
        this.cooldownTimer = 0;
    }

    onKeydownDraw(): void {
        this.player.ctx.fillStyle = '#55ff5530';
        this.player.engine.FillCircle(this.player.engine.mouseWorldPosition, 32);
    }
}